export default {
    // 不走微信登录的页面路由名单   那些需要微信code（code不适用于微信登录的）
    // loginForUpgrades， getQr
    whiteMap: {
        loginForUpgrades: true,
        getQr: true,
        selectQrType: true,
    },
    isWhite(path) {
        let name = '';
        if (path && path.split('/') && path.split('/')[1]) {
            name = path.split('/')[1];
        }
        if (this.whiteMap[name]) {
           return true;
        } else {
           return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/wxList.js